module.exports = __webpack_public_path__ + "img/360_step_4.35248c03.png";